import { render, staticRenderFns } from "./DeliverableDatesRibbon.vue?vue&type=template&id=06f321e9&"
import script from "./DeliverableDatesRibbon.vue?vue&type=script&lang=js&"
export * from "./DeliverableDatesRibbon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06f321e9')) {
      api.createRecord('06f321e9', component.options)
    } else {
      api.reload('06f321e9', component.options)
    }
    module.hot.accept("./DeliverableDatesRibbon.vue?vue&type=template&id=06f321e9&", function () {
      api.rerender('06f321e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/DeliverableDatesRibbon.vue"
export default component.exports